import Smartphones from 'Salaries/views/SalariesListView/containers/Smartphones'
import Tablets from 'Salaries/views/SalariesListView/containers/Tablets'

import { getCurrentDeviceView } from 'shared/helpers/utils'

const SalariesListView = getCurrentDeviceView(Smartphones, Tablets)

export default SalariesListView
